import React from 'react';
import _ from 'lodash';
import View from 'components/ui/view';
import Text from 'components/ui/text';
import PaymentLogo from 'components/payment/logo';
import { isTotalLineItem } from 'shared/models/order';

export default function OrderPayment({ order }) {
  const card = (order.charge && order.charge.source) || {};
  const totalLineItem = _.find(order.line_items, isTotalLineItem) || {};
  const total = totalLineItem.display;
  const preTipTotal = order.total || 0;
  const tip = order.order_tip || 0;

  return (
    <View padding={{ top: 'md', bottom: 'md' }}>
      <div className="row middle-xs">
        <div className="col-xs-9">
          {card.brand && <PaymentLogo brand={card.brand} className="left" />}
          {card.brand && (
            <span className="col-xs">{`${card.brand || ''} ${card.last4 ||
              ''}`}</span>
          )}
        </div>
        <div className="col-xs-3">
          <Text size="lg" weight="bold" className="text-right">
            {total}
          </Text>
        </div>
      </div>

      {!!preTipTotal &&
        !!tip && (
          <div className="row">
            <div className="col-xs-12">
              <Text secondary weight="light">
                Your card was charged ${preTipTotal.toFixed(2)} + ${tip.toFixed(2)}{' '}
                for tip.
              </Text>
            </div>
          </div>
        )}
    </View>
  );
}
